import { useEffect, useState } from "react";

function ShoppingCartPackage(props) {
  let { val, item, recipientArray, ind, radiovalue, mobileview } = props;

  let testItem = item.details[0].items[0]
  console.log(item, "ShoppingCartPackage item")

  const [checked, setChecked] = useState(false);

  const [checkedState, setCheckedState] = useState();

  const handleRadio = (e, id, val) => {
    setChecked(e.target.checked);
    props.handleRadio(id, val);
  };

  useEffect(() => {
    if (radiovalue && JSON.stringify(radiovalue).includes(val.uuid)) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [radiovalue]);

  return (
    <>
      <div className="inner-content-row-wrap" key={ind}>
        <div className="col-md-4">
          <div className="left-cont-out">
            <div className="top-font">
              {val.panel_name} ({testItem.patient_uuid[0]})
            </div>
            <div>
              <span style={{ color: 'orange' }}>FREE</span> medical Report
            </div>
            <div>
              <span style={{ color: 'orange' }}>FREE MEDICAL OFFICER</span> follow-up consultation (worth ₦8,600)
            </div>
            <div style={{ marginTop: '20px' }}>
              <span>Results Expected in : 2 Days</span>
            </div>

          </div>
        </div>

        {!mobileview ? (
          <>
            <div className="col-md-2">
              <div className="center-cont-out">
                <div className="top-font">{testItem.quantity && testItem.quantity}</div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="center-cont-out">
                <div className="top-font">
                  ₦{Number(item.details[0].amount).toFixed()}
                </div>
                {/* <div className="bottom-font">₦{Number(val.tests.labretailprice).toFixed()}</div> */}
              </div>
            </div>
          </>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className="col-md-2">
              <div className="center-cont-out">
                <span>Quantity</span>
                  <div className="top-font">{testItem.quantity && testItem.quantity}</div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="center-cont-out">
                <div className="top-font">
                  ₦{val.tests.doctallsexclusivediscountedprice}
                </div>
                {/* <div className="bottom-font">₦{val.tests.labretailprice}</div> */}
              </div>
            </div>
          </div>
        )}

        <div className="col-md-4">
          <div className="right-cont-out" style={{width:"100%",paddingLeft:"5%"}}>
            {testItem.patient_name[0]
              .toString()
              .replace(",", ",                      ")}
          </div>
        </div>
      </div>
    </>
  );
}

export default ShoppingCartPackage;
